import type { PartSvgProps } from './types'

export default function StockSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 160,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 160 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Buffer tube cylinder */}
      <rect x="8" y="32" width="80" height="16" rx="8"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Adjustment notches on tube */}
      {[24, 34, 44, 54, 64].map((x) => (
        <line key={x} x1={x} y1={32} x2={x} y2={48}
              stroke={stroke} strokeWidth="0.8" />
      ))}
      {/* Stock body */}
      <path d="M 88 28 L 140 18 L 152 22 L 152 58 L 140 62 L 88 52 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Cheek weld shelf */}
      <path d="M 96 28 L 136 20 L 140 28 L 98 36 Z"
            fill={fill} stroke={accent} strokeWidth="1" />
      {/* Butt pad */}
      <rect x="146" y="20" width="10" height="40" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1.2" />
      {/* Lock mechanism detail */}
      <circle cx="92" cy="40" r="5" fill="none" stroke={accent} strokeWidth="1.2" />
    </svg>
  )
}
